import React, {  useEffect, useState } from "react";
import { McModal } from "@maersk-global/mds-react-wrapper/mc-modal";
import Select from "react-select";
import apiClient from "../api/apiClient";
import { Button } from "@mui/material";
import { McDateRange } from "@maersk-global/mds-react-wrapper/components-core/mc-date-range";
import { apiUrl } from "../authconfig";

const ViewCreationModal = ({handleClose,ViewModal,filterOptions,fetchViewList,allViewList}) => {
     const [status, setStatus] = useState(['View1','View2','View3']);
     const [selectedView, setSelectedView] = useState();
     const currentUser = JSON.parse(sessionStorage.getItem("user"));
       const [selectedFilters, setSelectedFilters] = useState({
         projectIds: null,
         opportunityReferences: null,
         accountNames: null,
         assignedUsers: null,
         productBundles: null,
         area: null,
         region: null,
         cxChannels: null,
         assignedToFunctions: null,
         countries: null,
         countryRoles: null,
         projectPhases: null,
         projectStatuses: null,
         vertical: null,
         brand: null,
         customerProgram: null,
         salesChannel: null,
         fromDate: null,
         toDate: null,
       });
       const customStyles = {
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isFocused ? "#f0f8ff" : "white", 
          color: state.isFocused ? "#0078d7" : "black", 
          cursor: "pointer",
        }),
        control: (provided) => ({
          ...provided,
          borderColor: "#cfcfcf",
          "&:hover": {
            borderColor: "#0078d7", 
          },
        }),
      };
    
      useEffect(() => {
        if (selectedView) {
          const selectedViewData = allViewList.find(
            (view) => view.viewName === selectedView.value
          );
          if (selectedViewData) {
            setSelectedFilters(selectedViewData);
          }
        }
      }, [selectedView]);

     const setDateFilter = (event) => {
        if (
          selectedFilters.fromDate !== event.target.value.from ||
          selectedFilters.toDate !== event.target.value.to
        )
        
        {
          setSelectedFilters((prevState) => ({
            ...prevState,
            fromDate: event.target.value.from,
            toDate: event.target.value.to,
            fromToChanged: true,
          }));
        }
      };

      const handleFilterChange = (field, value) => {
        console.log(
          "handleFilterChange called with field:",
          field,
          "and value:",
          value
        );
        setSelectedFilters((prevFilters) => {
          if (field === "region") {
            return {
              ...prevFilters,
              region: value ? value.value : null,
              area: null, 
              countries:null,
            };
           } else if (field === "area") {
              return {
                ...prevFilters,
                area: value ? value.value : null,
                countries: null, 
              };
            } else if (field === "dateFilter") {
            return {
              ...prevFilters,
              fromDate: value ? value.fromDate : null,
              toDate: value ? value.toDate : null,
              fromToChanged: true,
            };
          } else {
            return {
              ...prevFilters,
              [field]: value ? value.value : null,
            };
          }
        });
    //     if (
    //       field === "assignedUsers" &&
    //       !filterOptions.assignedUsers.includes(value?.value)
    //     ) {
    //       setUserNotAssigned(true);
    //     } else {
    //       setUserNotAssigned(false);
    //     }
       };

       const handleSubmit = () => {
        const currentView = allViewList?.find((item) => item.viewName === selectedView.value);
        if(currentView) {
            const requestBody = {
              ...currentView,
              projectIds: selectedFilters.projectIds
              ? selectedFilters.projectIds
              : "",
              area: selectedFilters.area
              ? selectedFilters.area
              : "",
            region: selectedFilters.region
              ? selectedFilters.region
              : "",
            assignedUsers: selectedFilters.assignedUsers
              ? selectedFilters.assignedUsers
              : "",
            opportunityReferences: selectedFilters.opportunityReferences
              ? selectedFilters.opportunityReferences
              : "",
            accountNames: selectedFilters.accountNames
              ? selectedFilters.accountNames
              : "",
            productBundles: selectedFilters.productBundles
              ? selectedFilters.productBundles
              : "",
            cxChannels: selectedFilters.cxChannels
              ? selectedFilters.cxChannels
              : "",
            assignedToFunctions: selectedFilters.assignedToFunctions
              ? selectedFilters.assignedToFunctions
              : "",
              regionAreaCountryMap: selectedFilters.region
              ? {
                  [selectedFilters.region]: selectedFilters.area
                    ? {
                        [selectedFilters.area]: selectedFilters.countries ? [selectedFilters.countries] : [],
                      }
                    : {},
                }
              : {},
            countryRoles: selectedFilters.countryRoles
              ? selectedFilters.countryRoles
              : "",
            projectPhases: selectedFilters.projectPhases
              ? selectedFilters.projectPhases
              : "",
            projectStatuses: selectedFilters.projectStatuses
              ? selectedFilters.projectStatuses
              : "",
              vertical: selectedFilters.vertical
              ? selectedFilters.vertical
              : "",
              brand: selectedFilters.brand
              ? selectedFilters.brand
              : "",
              customerProgram: selectedFilters.customerProgram
              ? selectedFilters.customerProgram
              : "",
              salesChannel: selectedFilters.salesChannel
              ? selectedFilters.salesChannel
              : "",
            fromDate: selectedFilters.fromDate ? selectedFilters.fromDate : null,
            toDate: selectedFilters.toDate ? selectedFilters.toDate : null,
            }

            apiClient.put(`${apiUrl}/api/user-filter-views/${currentView?.id}`,requestBody )
            .then((response) => {
                console.log(response);
                alert("View Updated Successfully");
                fetchViewList();
                handleClose();
              }
              )
              .catch((error) => {
                alert(error.response.data || "Something went wrong");
                console.log(error);
              }
              );
        }
        else{
        const requestBody = {
            userEmail: currentUser?.mail,
            userName: currentUser?.displayName,
            projectIds: selectedFilters.projectIds
              ? selectedFilters.projectIds
              : "",
            assignedUsers: selectedFilters.assignedUsers
              ? selectedFilters.assignedUsers
              : "",
            opportunityReferences: selectedFilters.opportunityReferences
              ? selectedFilters.opportunityReferences
              : "",
            accountNames: selectedFilters.accountNames
              ? selectedFilters.accountNames
              : "",
            productBundles: selectedFilters.productBundles
              ? selectedFilters.productBundles
              : "",
            cxChannels: selectedFilters.cxChannels
              ? selectedFilters.cxChannels
              : "",
            assignedToFunctions: selectedFilters.assignedToFunctions
              ? selectedFilters.assignedToFunctions
              : "",
              regionAreaCountryMap: selectedFilters.region
              ? {
                  [selectedFilters.region]: selectedFilters.area
                    ? {
                        [selectedFilters.area]: selectedFilters.countries ? [selectedFilters.countries] : [],
                      }
                    : {},
                }
              : {},
            countryRoles: selectedFilters.countryRoles
              ? selectedFilters.countryRoles
              : "",
            projectPhases: selectedFilters.projectPhases
              ? selectedFilters.projectPhases
              : "",
            projectStatuses: selectedFilters.projectStatuses
              ? selectedFilters.projectStatuses
              : "",
              vertical: selectedFilters.vertical
              ? selectedFilters.vertical
              : "",
              brand: selectedFilters.brand
              ? selectedFilters.brand
              : "",
              customerProgram: selectedFilters.customerProgram
              ? selectedFilters.customerProgram
              : "",
              salesChannel: selectedFilters.salesChannel
              ? selectedFilters.salesChannel
              : "",
            fromDate: selectedFilters.fromDate ? selectedFilters.fromDate : null,
            toDate: selectedFilters.toDate ? selectedFilters.toDate : null,
            viewName: selectedView.value,
          };
        apiClient.post(`${apiUrl}/api/user-filter-views/save`,requestBody )
        .then((response) => {
            console.log(response);
            alert("View Created Successfully");
            fetchViewList();
            handleClose();
          })
          .catch((error) => {
            alert(error.response.data || "Something went wrong");
            console.log(error);
          });
        }
       }

       const handleDelete =()=>{
        apiClient
          .delete(`${apiUrl}/api/user-filter-views/${selectedFilters.id}`)
          .then((response) => {
            console.log(response);
            alert("View Deleted Successfully");
            fetchViewList();
            handleClose();
          })
          .catch((error) => {
            alert(error.response.data || "Something went wrong");
            console.log(error);
          });

       }

       console.log("selectedFilters", selectedFilters);

  return (
    <div>
      <McModal
        closed={
          handleClose
        }
        open={ViewModal}
        width="60vw"
        height={selectedView ? "80vh" : "50vh"}
      >
        <div
          style={{
            marginBottom: "20px",
            background: "rgb(66, 176, 213)",
            color: "#fff",
            justifyContent: "space-evenly",
            borderRadius: "5px",
          }}
        >
          <p
            style={{
              fontSize: "16px",
              margin: "5px",
              fontFamily: "Maersk Text",
            }}
          >
            <b>Create a New View or Edit an Existing one</b>
          </p>
        </div>
        <div style={{display:'flex',gap:'20px',alignItems:'center',width:'100%',paddingLeft:'5px'}}>
            <b>Select View : </b>
            <div  style={{width:'80%'}}>
          <Select
            options={status.map((item) => ({
              value: item,
              label: item,
            }))}
            placeholder="Select View"
            isClearable
            label="Select View"
            value={selectedView}
            onChange={(value) => {
              setSelectedFilters({})
              setSelectedView(value)
            
            }}
          />
          </div>
        </div>
       {selectedView && <><div
            style={{
                marginTop: "20px",
              display: "flex",
              gap: "2%",
              flexWrap: "wrap",
              marginBottom: "20px",
              border: "1px solid #cfcfcf",
              padding: "10px",
              backgroundColor: "#ededed",
              minHeight: '100%'
            }}
          >
            <div style={{ width: "49%",marginBottom:'20px' }}>
              <Select
                styles={customStyles}
                options={filterOptions.projectIds.map((id) => ({
                  value: id,
                  label: id,
                }))}
                placeholder="Project ID"
                value={
                  selectedFilters?.projectIds && {
                    value: selectedFilters?.projectIds,
                    label: selectedFilters?.projectIds,
                  }
                }
                isClearable
                onChange={(value) => handleFilterChange("projectIds", value)}
              />
            </div>
            <div style={{ width: "49%",marginBottom:'20px' }}>
              <Select
                styles={customStyles}
                options={filterOptions.opportunityReferences?.map((ref) => ({
                  value: ref,
                  label: ref,
                }))}
                placeholder="Opportunity Reference"
                isClearable
                value={
                  selectedFilters?.opportunityReferences && {
                    value: selectedFilters?.opportunityReferences,
                    label: selectedFilters?.opportunityReferences,
                  }
                }
                onChange={(value) =>
                  handleFilterChange("opportunityReferences", value)
                }
              />
            </div>
            <div style={{ width: "49%",marginBottom:'20px' }}>
              <Select
                styles={customStyles}
                options={filterOptions.accountNames?.map((name) => ({
                  value: name,
                  label: name,
                }))}
                placeholder="Account Name"
                isClearable
                value={
                  selectedFilters?.accountNames && {
                    value: selectedFilters?.accountNames,
                    label: selectedFilters?.accountNames,
                  }
                }
                onChange={(value) => handleFilterChange("accountNames", value)}
              />
            </div>
            <div style={{ width: "49%",marginBottom:'20px' }}>
              <Select
                styles={customStyles}
                options={filterOptions.assignedUsers?.map((user) => ({
                  value: user,
                  label: user,
                }))}
                placeholder="Assigned User"
                isClearable
                value={
                  selectedFilters?.assignedUsers && {
                    value: selectedFilters?.assignedUsers,
                    label: selectedFilters?.assignedUsers,
                  }
                }
                onChange={(value) => handleFilterChange("assignedUsers", value)}
              />
            </div>
            <div style={{ width: "49%",marginBottom:'20px' }}>
              <Select
                styles={customStyles}
                options={filterOptions?.productBundles?.map((family) => ({
                  value: family,
                  label: family,
                }))}
                placeholder="Product Family"
                value={
                  selectedFilters?.productBundles && {
                    value: selectedFilters?.productBundles,
                    label: selectedFilters?.productBundles,
                  }
                }
                isClearable
                onChange={(value) =>
                  handleFilterChange("productBundles", value)
                }
              />
            </div>
            <div style={{ width: "49%",marginBottom:'20px' }}>
              <Select
                styles={customStyles}
                options={filterOptions?.cxChannels?.map((channel) => ({
                  value: channel,
                  label: channel,
                }))}
                placeholder="CX Channel"
                value={
                  selectedFilters?.cxChannels && {
                    value: selectedFilters?.cxChannels,
                    label: selectedFilters?.cxChannels,
                  }
                }
                isClearable
                onChange={(value) => handleFilterChange("cxChannels", value)}
              />
            </div>
            <div style={{ width: "49%",marginBottom:'20px' }}>
              <Select
                styles={customStyles}
                options={filterOptions?.assignedToFunctions?.map((func) => ({
                  value: func,
                  label: func,
                }))}
                placeholder="Assigned To Function"
                value={
                  selectedFilters?.assignedToFunctions && {
                    value: selectedFilters?.assignedToFunctions,
                    label: selectedFilters?.assignedToFunctions,
                  }
                }
                isClearable
                onChange={(value) =>
                  handleFilterChange("assignedToFunctions", value)
                }
              />
            </div>
            <div style={{ width: "49%",marginBottom:'20px' }}>
            <Select
                styles={customStyles}
                options={Object.keys(filterOptions.regionAreaCountryMap || {}).map((region) => ({
                  value: region,
                  label: region,
                }))}
                placeholder="Region"
                value={
                  selectedFilters?.region && {
                    value: selectedFilters?.region,
                    label: selectedFilters?.region,
                  }
                }
                isClearable
                onChange={(value) =>
                  handleFilterChange("region", value)
                }
              />
              </div>
              <div style={{ width: "49%",marginBottom:'20px' }}>
            <Select
                styles={customStyles}
                options={
                  selectedFilters?.region &&
                  filterOptions?.regionAreaCountryMap &&
                  typeof filterOptions.regionAreaCountryMap[selectedFilters.region] === "object"
                    ? Object.keys(filterOptions.regionAreaCountryMap[selectedFilters.region]).map((area) => ({
                        value: area,
                        label: area,
                      }))
                    : []
                }
                placeholder="Area"
                value={
                  selectedFilters?.area && {
                    value: selectedFilters?.area,
                    label: selectedFilters?.area,
                  }
                }
                isClearable
                onChange={(value) =>
                  handleFilterChange("area", value)
                }
                noOptionsMessage={() =>
                  !selectedFilters?.region 
                    ?       <span style={{ color: "red" }}>Please select a value in Region first</span>
                    : "No options available"
                }
              />
              </div>
              <div style={{ width: "49%",marginBottom:'20px' }}>
              <Select
                styles={customStyles}
                options={
                  selectedFilters?.region &&
                  selectedFilters?.area &&
                  filterOptions?.regionAreaCountryMap &&
                  filterOptions.regionAreaCountryMap[selectedFilters.region] &&
                  Array.isArray(filterOptions.regionAreaCountryMap[selectedFilters.region][selectedFilters.area])
                    ? filterOptions.regionAreaCountryMap[selectedFilters.region][selectedFilters.area].map((country) => ({
                        value: country,
                        label: country,
                      }))
                    : []
                }
                placeholder="Country"
                value={
                  selectedFilters?.countries && {
                    value: selectedFilters?.countries,
                    label: selectedFilters?.countries,
                  }
                }
                isClearable
                onChange={(value) => handleFilterChange("countries", value)}
                noOptionsMessage={() =>
                  !selectedFilters?.region || !selectedFilters?.area
                    ? <span style={{ color: "red" }}>Please select values in Region and Area</span>
                    : "No options available"
                }
              />
            </div>
            <div style={{ width: "49%",marginBottom:'20px' }}>
              <Select
                styles={customStyles}
                options={filterOptions.countryRoles?.map((role) => ({
                  value: role,
                  label: role,
                }))}
                placeholder="Country Role"
                value={
                  selectedFilters?.countryRoles && {
                    value: selectedFilters?.countryRoles,
                    label: selectedFilters?.countryRoles,
                  }
                }
                isClearable
                onChange={(value) => handleFilterChange("countryRoles", value)}
              />
            </div>
            <div style={{ width: "49%",marginBottom:'20px' }}>
              <Select
                styles={customStyles}
                options={filterOptions.projectPhases?.map((phase) => ({
                  value: phase,
                  label: phase,
                }))}
                placeholder="Project Phase"
                value={
                  selectedFilters?.projectPhases && {
                    value: selectedFilters?.projectPhases,
                    label: selectedFilters?.projectPhases,
                  }
                }
                isClearable
                onChange={(value) => handleFilterChange("projectPhases", value)}
              />
            </div>
            <div style={{ width: "49%",marginBottom:'20px' }}>
              <Select
                styles={customStyles}
                options={filterOptions.projectStatuses?.map((status) => ({
                  value: status,
                  label: status,
                }))}
                placeholder="Project Status"
                value={
                  selectedFilters?.projectStatuses && {
                    value: selectedFilters?.projectStatuses,
                    label: selectedFilters?.projectStatuses,
                  }
                }
                isClearable
                onChange={(value) =>
                  handleFilterChange("projectStatuses", value)
                }
              />
            </div>
            <div style={{ width: "49%",marginBottom:'20px' }}>
              <Select
                styles={customStyles}
                options={filterOptions.vertical?.map((status) => ({
                  value: status,
                  label: status,
                }))}
                placeholder="Vertical"
                value={
                  selectedFilters?.vertical && {
                    value: selectedFilters?.vertical,
                    label: selectedFilters?.vertical,
                  }
                }
                isClearable
                onChange={(value) =>
                  handleFilterChange("vertical", value)
                }
              />
            </div>
            <div style={{ width: "49%",marginBottom:'20px' }}>
              <Select
                styles={customStyles}
                options={filterOptions.brand?.map((status) => ({
                  value: status,
                  label: status,
                }))}
                placeholder="Brand"
                value={
                  selectedFilters?.brand && {
                    value: selectedFilters?.brand,
                    label: selectedFilters?.brand,
                  }
                }
                isClearable
                onChange={(value) =>
                  handleFilterChange("brand", value)
                }
              />
            </div>
            <div style={{ width: "49%",marginBottom:'20px' }}>
              <Select
                styles={customStyles}
                options={filterOptions.customerProgram?.map((status) => ({
                  value: status,
                  label: status,
                }))}
                placeholder="Customer Program"
                value={
                  selectedFilters?.customerProgram && {
                    value: selectedFilters?.customerProgram,
                    label: selectedFilters?.customerProgram,
                  }
                }
                isClearable
                onChange={(value) =>
                  handleFilterChange("customerProgram", value)
                }
              />
            </div>
            <div style={{ width: "49%",marginBottom:'20px' }}>
              <Select
                styles={customStyles}
                options={filterOptions.salesChannel?.map((status) => ({
                  value: status,
                  label: status,
                }))}
                placeholder="Sales Channel"
                value={
                  selectedFilters?.salesChannel && {
                    value: selectedFilters?.salesChannel,
                    label: selectedFilters?.salesChannel,
                  }
                }
                isClearable
                onChange={(value) =>
                  handleFilterChange("salesChannel", value)
                }
              />
            </div>

            <div
              style={{
                border: "1px solid #cfcfcf",
                borderRadius: "4px",
                padding: "0 0 0 10px",
                backgroundColor: "#fff",
                display: "flex",
                alignItems: "center",
              }}
            >
              <McDateRange
                className="custom-date-range"
                labelposition="left"
                name="dateFilter"
                format="YYYY-MM-DD"
                placeholder="YYYY-MM-DD"
                fit="small"
                style={{ marginRight: "12px" }}
                input={(value) => setDateFilter(value)}
                value={{
                  from: selectedFilters.fromDate,
                  to: selectedFilters.toDate,
                }} 
              />
            </div>
          </div>

        <div  style={{display:'flex',gap:'40px',alignContent:'center',justifyContent:'center'}}>
          <Button
            variant="contained"
            style={{
              display: "block",
              margin: "20px 0",
              justifyItems: "center",
              width: "150px",
              padding: "10px",
              backgroundColor: "#00243D",
            }}
            onClick={() => handleSubmit()}
           // disabled={!comment}
          >
           { allViewList.some(
            (view) => view.viewName === selectedView.value
          ) ? 'Update': 'Submit'}
          </Button>
         {allViewList.some(
            (view) => view.viewName === selectedView.value
          ) && <Button
            variant="contained"
            style={{
              display: "block",
              margin: "20px 0",
              justifyItems: "center",
              width: "150px",
              padding: "10px",
              backgroundColor: "#00243D",
            }}
            onClick={() => handleDelete()}
           // disabled={!comment}
          >
Delete
          </Button>}
        </div></>}
      </McModal>
    </div>
  )
}

export default ViewCreationModal
